(function($, Drupal) {
  var breakpoint = [544, 768, 1024, 1280, 1680, 1920, 2400];
  var is_empty_cart = true;

  function isMobile() {
    return $(window).width() <= breakpoint[0];
  }

  /**
   * Check if the resolution is tab
   * @returns boolean
   */
  function isTab() {
    return $(window).width() <= breakpoint[1] && !isMobile();
  }

  /**
   * Check if the resolution is desk
   * returns boolean
   */
  function isDesk() {
    return $(window).width() <= breakpoint[2] && !isTab();
  }

  /**
   * Check if the resolution is large
   * returns boolean
   */
  function isLarge() {
    return $(window).width() <= breakpoint[3] && !isDesk();
  }

  /**
   * Check if the resolution is big
   * returns boolean
   */
  function isBig() {
    return $(window).width() <= breakpoint[4] && !isLarge();
  }

  /**
   * Check if the resolution is huge
   * returns boolean
   */
  function isHuge() {
    return $(window).width() <= breakpoint[5] && !isBig();
  }

  /**
   * Process annimated scroll
   * @param {*} $target
   * @param {*} duration
   * @param {*} callback
   */
  function mScrollTo($target, duration, offset, callback) {
    console.debug('scrollTop', $target.position().top);
    $('html').animate(
      {
        scrollTop: $target.position().top - offset
      },
      duration,
      function() {
        callback();
      }
    );
  }

  /**
   * Do things when sticky
   */
  function stickyThings() {
    var scrollPosition = $(window).scrollTop();
    var H = $(window).height();
    var $header = $('.header');
    headerH = $header.outerHeight();

    if (!isMobile() && !isTab()) {
      if (scrollPosition > H - 100 && scrollPosition < H) {
        $('.banner').addClass(['sticky', 'transparent']);
        $('.logo').addClass(['sticky', 'transparent']);
      }
      else if (scrollPosition >= H) {
        $('.banner').removeClass('transparent');
        $('.logo').removeClass('transparent');
      }
      else {
        $('.banner').removeClass(['sticky', 'transparent']);
        $('.logo').removeClass(['sticky', 'transparent']);
      }
    }
  }

  function lockBodyScroll(b = true) {
    if (b) {
      // prevent body from scrolling
      $('body').addClass('noScroll');
    }
    else {
      $('body').removeClass('noScroll');
    }
  }

  function placeholder() {
    console.debug('placeholder !!!');
    var $form = $('.user-login-form');
    $(
      '.js-form-type-textfield, .js-form-type-email, .js-form-type-password'
    ).each(function() {
      var label = $('label', $(this)).text();
      console.debug('label', label);
      $('input', $(this)).attr('placeholder', label);
    });
  }

  /**
   * Makes mobile menu
   */
  function mobileMenu() {
    var $mainMenu = $('.menu.main');
    var $burger = $('<div id="burger">burger</div>');
    var $wrapper = $(
      '<div id="mobile-menu-wrapper" class="mobile-menu-wrapper"></div>'
    );
    var $mobileMenu = $wrapper
      .prepend(
        $mainMenu
          .clone()
          .wrap('<div id="mobile-menu" class="mobile-menu"></div>')
          .parent()
      )
      .prepend($burger);
    $('body').prepend($mobileMenu);
    Drupal.attachBehaviors($mobileMenu);
    $('#burger').click(function() {
      lockBodyScroll(true);
      $('.mobile-menu').addClass('on');
    });
    $('#mobile-menu').click(function() {
      lockBodyScroll(false);
      $(this).removeClass('on');
    });
    $('#burger').headroom();
  }

  /*
   * Menu actions
   */
  function callToAction(trigger, link, anchor, target, offset) {
    console.debug('call to action');
    switch (target) {
      case 'link':
        console.debug('link');
        location.href = link + '?anchor=' + anchor;
        break;
      case 'self':
        console.debug('self');
        mScrollTo($(anchor), 1000, offset, function() {
          console.debug('scroll done!');
        });
        break;
    }
  }

  /**
   * Drupal behaviors
   */
  Drupal.behaviors.pascal = {
    attach: function(context, settings) {
      $('.site-cta', context).click(function(e) {
        e.preventDefault();
        callToAction(
          $(this),
          null,
          '.node.home',
          'self',
          parseInt($('.layout-content').css('margin-top'))
        );
      });

      $('.products-trigger, .ici', context).click(function(e) {
        e.preventDefault();
        callToAction(
          $(this),
          $(this).attr('href'),
          '.products',
          isHome() ? 'self' : 'link',
          0
        );
      });

      $('.shops-trigger', context).click(function(e) {
        e.preventDefault();
        var offset = 0;
        if (isMobile()) {
          offset = 0;
        }
        else if (isTab()) {
          offset = 0;
        }
        else if (isDesk()) {
          offset = 50;
        }
        else if (isLarge()) {
          offset = 50;
        }
        else if (isBig()) {
          offset = 100;
        }
        else if (isHuge()) {
          offset = 100;
        }
        callToAction(
          $(this),
          $(this).attr('href'),
          '.block-shops',
          isHome() ? 'self' : 'link',
          offset
        );
      });

      $('.contact-trigger', context).click(function(e) {
        var offset = 0;
        if (isMobile()) {
          offset = 0;
        }
        else if (isTab()) {
          offset = 0;
        }
        else if (isDesk()) {
          offset = 200;
        }
        else if (isLarge()) {
          offset = 190;
        }
        else if (isBig()) {
          offset = 180;
        }
        else if (isHuge()) {
          offset = 100;
        }
        e.preventDefault();
        callToAction(
          $(this),
          $(this).attr('href'),
          '.block-contact-block',
          isHome() ? 'self' : 'link',
          offset
        );
      });

      $('.product', context).hover(
        function(e) {
          if ($('.product-images[data-n=2]', this).length) {
            console.debug('product hover');
            $('.product-image[data-index=0]', this).addClass('off');
            $('.product-image[data-index=1]', this).removeClass('off');
          }
        },
        function(e) {
          if ($('.product-images[data-n=2]', this).length) {
            console.debug('product out');
            $('.product-image[data-index=0]', this).removeClass('off');
            $('.product-image[data-index=1]', this).addClass('off');
          }
        }
      );

      $('.product-images-wrapper, .product-title', context).click(function(e) {
        e.preventDefault();
        console.debug('product image click');
        $product = $(this).parent();
        $form = $('.commerce-order-item-add-to-cart-form', $product);
        $('.button--add-to-cart', $form).trigger('click');
      });

      $('.button--add-to-cart', context).click(function(e) {
        function getRandomInt(min, max) {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min)) + min;
        }
        $.fn.pigfall = function(X, Y, easing, t) {
          var $pig = $(this);
          $pig
            .removeClass('fallen')
            .addClass('rotating')
            .css({
              top: '-50%',
              left: X - $pig.width() / 2
            });
          $pig.animate(
            {
              top: Y + $pig.height() / 2
            },
            t,
            easing,
            function() {
              console.debug('Fall complete.', Y);
              $pig.removeClass('rotating').addClass('fallen');
              setTimeout(function() {
                //$('.pig-throbber').remove();
                $pig.remove();
              }, 250);
            }
          );
          return false;
        };
        e.preventDefault();
        var offset = $(this).offset();
        var x = getRandomInt(2, 8);
        var t = 750;
        $('body').prepend('<div class="pig-throbber"></div>');
        for (var i = 1; i < x; i++) {
          console.debug('i', i);
          $('body').prepend(
            $('<div class="pig falling pig' + i + '">cochon 2<div>')
          );
          $('.pig' + i).pigfall(
            offset.left + $(this).width() / 2,
            offset.top - $(window).scrollTop(),
            'linear',
            i * t
          );
        }

        setTimeout(function() {
          $('.pig-throbber').remove();
          $('.block-commerce-cart-wrapper').removeClass('off');
        }, (x - 1) * t);

        return false;
      });

      $('.cart-button.cart-continue', context).click(function(e) {
        console.debug('cart close');
        if (isHome()) {
          $('.block-commerce-cart-wrapper').addClass('off');
          lockBodyScroll(false);
        }
        else {
          location.href = '/?anchor=.products';
        }
      });

      $('.block-commerce-cart-close', context).click(function(e) {
        console.debug('cart close');
        $('.block-commerce-cart-wrapper').addClass('off');
        lockBodyScroll(false);
      });

      $('.basket-trigger', context).click(function(e) {
        $('.block-commerce-cart-wrapper').removeClass('off');
        lockBodyScroll();
      });

      $('.callme', context).click(function(e) {
        $('#block-appelezmoi').addClass('on');
        lockBodyScroll();
      });

      $('.callme-close', context).click(function(e) {
        $('#block-appelezmoi').removeClass('on');
        lockBodyScroll(false);
      });
    },
    detach: function(context, settings) {
      console.debug('behaviours detached');
    }
  };

  /**
   * Do things in html
   */
  function hackHTML() {
    console.debug('hack HTML');

    //$('.delete-order-item.button').attr('value', '');
    placeholder();

    if ($('.block-commerce-cart').hasClass('visually-hidden')) {
      $('.basket-trigger')
        .parent()
        .addClass('off');
    }

    // Hack video bg
    console.debug(
      $('.background-video')
        .attr('data-vide-bg')
        .match('poster:(.*)')[0]
    );
    $('.video').css(
      'bacground-image',
      $('.background-video')
        .attr('data-vide-bg')
        .match('poster:(.*)')[0] + ' !important'
    );
    /*
    $('.video > video')
      .attr(
        'src',
        'http://www.pascal.local:3000/sites/default/files/vide/production-ID_4455868.mp4'
      )
      .attr('type', 'video/mp4');
    */

    // Informations de facturation -> adresse
    $('.checkout-pane-billing-information .fieldset-legend').text('Adresse');

    // Order information, order fields hack
    if ($('div[class*="checkout-pane-order-fields"]').length) {
      $.fn.attrs = function(fnc) {
        var obj = {};
        $.each(this[0].attributes, function() {
          if (this.name == 'value') {
            return;
          } // Avoid someone (optional)
          if (this.specified) {
            obj[this.name] = this.value;
          }
        });
        return obj;
      };
      var attributes = $('div[class*="checkout-pane-order-fields"]').attrs();
      var content = $('div[class*="checkout-pane-order-fields"]').html();
      var $new = $('<fieldset></fieldset>')
        .html('<div class="fieldset-wrapper">' + content + '</div>')
        .prepend(
          '<legend><span class="fieldset-legend">Livraison</span><legend>'
        );
      $new.attr(attributes);
      Drupal.attachBehaviors($new);
      $('div[class*="checkout-pane-order-fields"]').replaceWith($new);

      /*
      $('#shipping-information-wrapper').css('display', 'none');
      $('.given-name.form-text').attr('value', 'John');
      $('.family-name.form-text').attr('value', 'Smith');
      $('.address-line1.form-text').attr('value', 'pas d\'adresse');
      $('.postal-code.form-text').attr('value', '00000');
      $('.locality.form-text').attr('value', 'Nulle part');
      */

      $('.form-item-order-fieldscheckout-field-delivery', $new).click(
        function() {
          var val = $('input[type="radio"]', this).attr('value');
          console.debug('radio value', val);
          if (val > 1) {
            $('#shipping-information-wrapper').css('display', 'block');
          }
          else {
            $('#shipping-information-wrapper').css('display', 'none');
          }
        }
      );
    }

    // Force product images size
    var w = $('.product-image.on').width();
    var h = $('.product-image.on').height();
    console.debug('prodcut image size', w, h);
    $('.product-image').css({
      width: w,
      height: w
    });

    // Products price and weigth hack
    $('.product.w-priceweight').each(function() {
      console.debug('ici');
      var priceweight = $('> .product-priceweight', this).text();
      var weight = $(
        '> div[class^="product--variation-field--variation_weight"]',
        this
      ).text();
      console.debug('priceweight', priceweight);
      console.debug('weight', weight);
    });
  }

  /**
   * Check if path is home
   */
  function isHome() {
    return $('.path-frontpage').length > 0;
  }

  /**
   * Do things when ready
   */
  function ready() {
    var currentUrl = $(location).attr('href');

    console.debug('ready');
    console.debug('mobile', isMobile());
    console.debug('tab', isTab());
    console.debug('desk', isDesk());
    console.debug('large', isLarge());
    console.debug('big', isBig());
    console.debug('huge', isHuge());

    if (isMobile() || isTab()) {
      mobileMenu();
    }
  }

  /**
   * Do things at scrolling
   * @return {boolean} true
   */
  function scroll() {
    stickyThings();
    return false;
  }

  /**
   * Do things when resized
   * @return {boolean} true
   */
  function resize() {
    console.debug('resize');
    return true;
  }

  /**
   * Do things when loaded
   * @returns {boolean} true
   */
  function loaded() {
    console.debug('loaded');

    $.urlParam = function(name, url) {
      if (!url) {
        url = window.location.href;
      }
      var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);
      if (!results) {
        return undefined;
      }
      return results[1] || undefined;
    };

    var query = $.urlParam('anchor');
    console.debug('query', query);
    if (!(typeof query === 'undefined')) {
      var duration = 1000;
      if (isHome()) {
        var offset = 200;
        mScrollTo($(query), duration, offset, function() {
          console.debug('scroll done');
        });
      }
    }

    hackHTML();
    return true;
  }

  $(window).ready(ready);
  $(window).scroll(scroll);
  $(window).resize(resize);

  $(window).on(
    'load',
    {
      passive: true
    },
    function(e) {
      loaded();
    }
  );

  /*
  $(document).on('ajaxComplete', function(event, xhr, settings) {
    // open cart block
    console.debug('ajax complete');
    hackHTML();
    if (
      xhr.responseJSON[0].selector == '.block-commerce-cart' ||
      xhr.responseJSON[1].selector == '.block-commerce-cart'
    ) {
      console.debug('cart ok');
      setTimeout(function() {
        $('.block-commerce-cart-wrapper').removeClass('off');
      }, 1000);

      is_empty_cart = false;
      lockBodyScroll();
      $('.basket-trigger')
        .parent()
        .removeClass('off');
    }
  });
  */
})(jQuery, Drupal);
